import React, { useState } from "react";
import { Modal, Alert } from "reactstrap";
import "../Chat.css";
import { BiCheck, BiCheckDouble } from "react-icons/bi";
import { Col, Row, Button, ModalBody, Badge } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileWord,
  faFile
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  FaPhone,
  FaUser,
  FaWhatsapp,
  FaCalendarAlt,
  FaClock,
  FaStickyNote
} from "react-icons/fa";

function ModalManagementDetails(props) {
  const URL_LARGE = process.env.REACT_APP_API_URL;
  const url = URL_LARGE.split("/api");
  const history = useHistory();
  const handleButtonClick = () => {
    props.onCloseClick();
  };
  console.log(props)
  const [imageModal, setImageModal] = useState("");
  const [imageOpen, setImageOpen] = useState(null);

  function getDocumentIcon(documentPath) {
    const extension = documentPath.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return (
          <FontAwesomeIcon icon={faFilePdf} className="text-danger me-2" />
        );
      case "doc":
      case "docx":
        return (
          <FontAwesomeIcon icon={faFileWord} className="text-primary me-2" />
        );
      default:
        return (
          <FontAwesomeIcon icon={faFile} className="text-secondary me-2" />
        );
    }
  }

  return (
    <div>
      <Modal
        isOpen={imageOpen}
        toggle={() => {
          setImageOpen(false);
          setImageModal("");
        }}
        size="xl"
      >
        <div>
          <div className="d-flex justify-content-center p-2">
            <div>
              <img
                className="max-size-img-modal"
                alt="Imagen"
                src={imageModal}
              />
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={props.isOpen}
        toggle={props.onCloseClick}
        centered={true}
        size="lg"
        className="management-modal"
      >
        <ModalBody className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-3">
            <div>
              <h4 className="m-0 text-primary">
                <strong>Gestión {props.GestionDetallada.id}</strong>
                {props.GestionDetallada.isLead && (
                  <FaUser className="ms-2 text-warning" title="Lead" />
                )}
              </h4>
              <div className="text-muted small mt-1">
                {props.GestionDetallada.created_date}
              </div>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={props.onCloseClick}
              aria-label="Close"
            ></button>
          </div>

          {/* Sección de contacto (estilizada) */}
          <div className="contact-section mb-2 p-3 bg-light rounded">
            <Row>
              <Col className="d-flex align-items-center">
                <div className="bg-primary text-white rounded-circle p-2 me-3">
                  {props.GestionDetallada.type === "WhatsApp" ? (
                    <FaWhatsapp size={18} />
                  ) : (
                    <FaPhone size={18} />
                  )}
                </div>
                <div>
                  <h5 className="m-0">{props.GestionDetallada.contacto}</h5>
                  <div className="text-muted small">
                    {props.GestionDetallada.agent?.[0]}
                  </div>
                </div>
              </Col>
              <Col className="d-flex align-items-center justify-content-end">
                {props.GestionDetallada.estado === "FINALIZADO" ? (
                  <Badge color="success" pill className="px-3 py-2">
                    Finalizado
                  </Badge>
                ) : props.GestionDetallada.estado === "VENCIDO" ? (
                  <Badge color="danger" pill className="px-3 py-2">
                    Vencido
                  </Badge>
                ) : props.GestionDetallada.estado === "EN_GESTION" ? (
                  <Badge
                    color="primary"
                    pill
                    className="px-3 py-2"
                    style={{ backgroundColor: "#6f42c1" }}
                  >
                    En Gestión
                  </Badge>
                ) : null}
              </Col>
            </Row>
          </div>
          <div>
            <h6 className="text-muted mb-2 d-flex align-items-center">
              <FaStickyNote className="me-2 text-primary" /> Observaciones
            </h6>
            <div className="p-3 bg-white rounded border">
              {props.GestionDetallada.observaciones ||
                "No hay observaciones registradas"}
            </div>
          </div>

          {props.GestionDetallada.historial_conversation ? (
            <Row>
              <div className="accordion mt-4" id="accordionWhatsApp">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingWhatsApp">
                    <button
                      className="accordion-button collapsed" // Añade 'collapsed' aquí
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseWhatsApp"
                      aria-expanded="false"
                      aria-controls="collapseWhatsApp"
                    >
                      <FaWhatsapp className="me-2 text-success" /> Ver Mensajes
                    </button>
                  </h2>
                  <div
                    id="collapseWhatsApp"
                    className="accordion-collapse collapse" 
                    aria-labelledby="headingWhatsApp"
                    data-bs-parent="#accordionWhatsApp"
                  >
                    <div
                      className="accordion-body"
                      style={{ maxHeight: "300px", display: "flex" }}
                    >
                      <div
                        className={
                          props.GestionDetallada.type === "Telegram"
                            ? "message-container-telegram"
                            : "message-container-light"
                        }
                      >
                        {Array.isArray(
                          props.GestionDetallada.historial_conversation
                        )
                          ? props.GestionDetallada.historial_conversation.map(
                              (message, messageIndex) => {
                                return (
                                  <div key={messageIndex}>
                                    {message.msg_type === "nota" ? (
                                      <Col
                                        lg={12}
                                        className="d-flex justify-content-end mt-2"
                                      >
                                        <Alert
                                          color="info"
                                          role="alert"
                                          className="mb-0 p-2"
                                          style={{ fontSize: "smaller" }}
                                        >
                                          <div>
                                            <b>{message.contacto}</b>
                                          </div>
                                          <div>{message.body}</div>
                                        </Alert>
                                      </Col>
                                    ) : message.msg_type === "image" ? (
                                      <div
                                        className={
                                          message.role === "From_me"
                                            ? "sent-message-light"
                                            : "received-message-light"
                                        }
                                      >
                                        {message.role === "From_me" ? (
                                          <div className="agent-name-light">
                                            <b>{message.contacto}</b>
                                          </div>
                                        ) : null}
                                        <div className="message-content mt-2">
                                          <img
                                            className="max-size-img"
                                            src={url[0] + message.file}
                                            alt="Imagen"
                                            onClick={() => {
                                              setImageOpen(true);
                                              setImageModal(
                                                url[0] + message.file
                                              );
                                            }}
                                          />
                                        </div>
                                        <div className="message-text mt-2">
                                          {message.caption}
                                        </div>
                                        <div className="mt-2">
                                          <div className="message-time-light">
                                            {message.time}
                                          </div>
                                          {message.role === "From_me" &&
                                            message.status === "read" && (
                                              <BiCheckDouble className="checkIcon-message read-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "sent" && (
                                              <BiCheck className="checkIcon-message delivered-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "delivered" && (
                                              <BiCheckDouble className="checkIcon-message" />
                                            )}
                                        </div>
                                      </div>
                                    ) : message.msg_type === "audio" ? (
                                      <div
                                        className={
                                          message.role === "From_me"
                                            ? "sent-message-light"
                                            : "received-message-light"
                                        }
                                      >
                                        {message.role === "From_me" ? (
                                          <div className="agent-name-light">
                                            <b>{message.contacto}</b>
                                          </div>
                                        ) : null}
                                        <div className="message-content mt-2">
                                          <audio controls>
                                            <source
                                              src={url[0] + message.file}
                                              type="audio/mpeg"
                                            />
                                            Your browser does not support the
                                            audio element.
                                          </audio>
                                        </div>
                                        <div className="message-text mt-1">
                                          {message.caption}
                                        </div>
                                        <div className="mt-1">
                                          <div className="message-time-light">
                                            {message.time}
                                          </div>
                                          {message.role === "From_me" &&
                                            message.status === "read" && (
                                              <BiCheckDouble className="checkIcon-message read-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "sent" && (
                                              <BiCheck className="checkIcon-message delivered-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "delivered" && (
                                              <BiCheckDouble className="checkIcon-message" />
                                            )}
                                        </div>
                                      </div>
                                    ) : message.msg_type === "video" ? (
                                      <div
                                        className={
                                          message.role === "From_me"
                                            ? "sent-message-light"
                                            : "received-message-light"
                                        }
                                      >
                                        {message.role === "From_me" ? (
                                          <div className="agent-name-light">
                                            <b>{message.contact}</b>
                                          </div>
                                        ) : null}
                                        <div className="message-content mt-2">
                                          <video
                                            controls
                                            className="max-size-img"
                                          >
                                            <source
                                              src={url[0] + message.file}
                                              type="video/mp4"
                                            />
                                            Your browser does not support the
                                            video element.
                                          </video>
                                        </div>
                                        <div className="message-text mt'1">
                                          {message.caption}
                                        </div>
                                        <div className="mt-2">
                                          <div className="message-time-light">
                                            {message.time}
                                          </div>
                                          {message.role === "From_me" &&
                                            message.status === "read" && (
                                              <BiCheckDouble className="checkIcon-message read-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "sent" && (
                                              <BiCheck className="checkIcon-message delivered-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "delivered" && (
                                              <BiCheckDouble className="checkIcon-message" />
                                            )}
                                        </div>
                                      </div>
                                    ) : message.msg_type === "document" ? (
                                      <div
                                        className={
                                          message.role === "From_me"
                                            ? "sent-message-light"
                                            : "received-message-light"
                                        }
                                      >
                                        {message.role === "From_me" ? (
                                          <div className="agent-name-light">
                                            <b>{message.contacto}</b>
                                          </div>
                                        ) : null}
                                        <div className="message-content mt-2">
                                          <a
                                            href={url[0] + message.file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="me-1 text-black"
                                          >
                                            {getDocumentIcon(message.file)}
                                            {message.filename}
                                          </a>
                                        </div>
                                        <div className="message-text mt-1">
                                          {message.caption}
                                        </div>
                                        <div className="mt-2">
                                          <div className="message-time-light">
                                            {message.time}
                                          </div>
                                          {message.role === "From_me" &&
                                            message.status === "read" && (
                                              <BiCheckDouble className="checkIcon-message read-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "sent" && (
                                              <BiCheck className="checkIcon-message delivered-icon" />
                                            )}
                                          {message.role === "From_me" &&
                                            message.status === "delivered" && (
                                              <BiCheckDouble className="checkIcon-message" />
                                            )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          message.role === "From_me"
                                            ? "sent-message-light"
                                            : "received-message-light"
                                        }
                                      >
                                        {message.role === "From_me" ? (
                                          <div className="agent-name-light">
                                            <b>{message.contacto}</b>
                                          </div>
                                        ) : null}
                                        <div className="message-content">
                                          <div className="message-text">
                                            {message.body}
                                          </div>
                                        </div>
                                        <div className="mt-2">
                                          <div className="message-time-light">
                                            {message.time}
                                          </div>
                                          {message.role === "From_me" &&
                                          message.status === "read" ? (
                                            <BiCheckDouble className="checkIcon-message read-icon" />
                                          ) : message.role === "From_me" &&
                                            message.status === "sent" ? (
                                            <BiCheck className="checkIcon-message delivered-icon" />
                                          ) : message.role === "From_me" &&
                                            message.status === "delivered" ? (
                                            <BiCheckDouble className="checkIcon-message" />
                                          ) : null}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              }
                            )
                          : []}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          ):[]}

          {/* Botones de acción (mejor estilo) */}
          <Row className="mt-4 pt-3 border-top">
            <Col className="d-flex justify-content-end">
              {props.GestionDetallada.type === "WhatsApp" && (
                <Button
                  className="btn btn-success me-2 d-flex align-items-center"
                  onClick={() => {
                    window.focus();
                    history.replace({
                      pathname: "/chat",
                      state: {
                        selectedChatId:
                          props.GestionDetallada.conversation &&
                          props.GestionDetallada.conversation,
                        contactId:
                          props.GestionDetallada.contacto_id &&
                          props.GestionDetallada.contacto_id,
                        type: "WhatsApp"
                      }
                    });
                  }}
                >
                  <FaWhatsapp className="me-2" />
                  Ir al Chat
                </Button>
              )}
              <Button
                className="btn btn-outline-secondary text-dark"
                onClick={() => {
                  handleButtonClick();
                }}
              >
                Cerrar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Estilos adicionales */}
      <style jsx>{`
        .management-modal {
          font-family: "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
          
        }
        .contact-section {
          background-color: #f8f9fa;
          border-left: 4px solid #0d6efd;
        }
        .info-card {
          transition: all 0.3s ease;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        }
        .info-card:hover {
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .accordion-button:not(.collapsed) {
          background-color: #f8f9fa;
          color: #0d6efd;
        }
      `}</style>
    </div>
  );
}

export default ModalManagementDetails;
